var exports = {
  "kL": "FriendsSkeleton.module__container___cGJqOU",
  "Em": "FriendsSkeleton.module__mainColumn___cGJqOU",
  "wx": "FriendsSkeleton.module__header___cGJqOU",
  "BS": "FriendsSkeleton.module__headerLeftSection___cGJqOU",
  "Gv": "FriendsSkeleton.module__backButton___cGJqOU",
  "cZ": "FriendsSkeleton.module__backButtonMobile___cGJqOU",
  "LD": "FriendsSkeleton.module__headerLeft___cGJqOU",
  "cP": "FriendsSkeleton.module__titleSection___cGJqOU",
  "yF": "FriendsSkeleton.module__divider___cGJqOU",
  "me": "FriendsSkeleton.module__tabsWrapper___cGJqOU",
  "VD": "FriendsSkeleton.module__tabsInner___cGJqOU",
  "IE": "FriendsSkeleton.module__headerRight___cGJqOU",
  "Qs": "FriendsSkeleton.module__content___cGJqOU",
  "sf": "FriendsSkeleton.module__searchWrapper___cGJqOU",
  "MJ": "FriendsSkeleton.module__tabBody___cGJqOU",
  "p_": "FriendsSkeleton.module__list___cGJqOU",
  "p$": "FriendsSkeleton.module__emptyState___cGJqOU",
  "AI": "FriendsSkeleton.module__emptyStateIcon___cGJqOU",
  "vo": "FriendsSkeleton.module__emptyStateTitle___cGJqOU",
  "F9": "FriendsSkeleton.module__emptyStateSubtitle___cGJqOU",
  "Gf": "FriendsSkeleton.module__sectionTitle___cGJqOU" + " " + __webpack_require__(551662)["Gf"],
  "Ge": "FriendsSkeleton.module__rows___cGJqOU" + " " + __webpack_require__(551662)["f5"],
  "GF": "FriendsSkeleton.module__rowsWithMargin___cGJqOU" + " " + __webpack_require__(551662)["v2"],
  "nM": "FriendsSkeleton.module__row___cGJqOU",
  "z2": "FriendsSkeleton.module__rowInfo___cGJqOU",
  "pt": "FriendsSkeleton.module__rowDetails___cGJqOU",
  "hj": "FriendsSkeleton.module__rowNameBand___cGJqOU",
  "f": "FriendsSkeleton.module__rowSubtextBand___cGJqOU",
  "cm": "FriendsSkeleton.module__rowActions___cGJqOU",
  "pz": "FriendsSkeleton.module__sidebar___cGJqOU",
  "aN": "FriendsSkeleton.module__sidebarHeader___cGJqOU",
  "wp": "FriendsSkeleton.module__sidebarContent___cGJqOU",
  "rF": "FriendsSkeleton.module__sidebarEmptyState___cGJqOU",
  "sM": "FriendsSkeleton.module__sidebarEmptyTitle___cGJqOU",
  "iZ": "FriendsSkeleton.module__sidebarEmptyDescription___cGJqOU",
  "KC": "FriendsSkeleton.module__sidebarEmptyDescriptionLine___cGJqOU",
  "H4": "FriendsSkeleton.module__activeNowCard___cGJqOU",
  "zO": "FriendsSkeleton.module__activeNowContextGroup___cGJqOU",
  "vA": "FriendsSkeleton.module__activeNowStatus___cGJqOU",
  "Ud": "FriendsSkeleton.module__activeNowContext___cGJqOU",
  "dr": "FriendsSkeleton.module__activeNowParticipants___cGJqOU",
  "$Q": "FriendsSkeleton.module__activeNowAction___cGJqOU",
};

module.exports = exports;
